// hooks
import { useCommonQuery } from 'hooks';

// modules
import type { BaseApiResponse, CommonQueryOptions, ResultError } from 'modules';

// apis
import { SmsAPI } from '../apis/sms.api';

// keys
import { smsKeys } from '../keys/sms.key';

// models
import type {
  ReqChangeNationMobile,
  ReqSendSms,
  ReqTempPassword,
  ReqVerifyCode,
  VerifyResult
} from '../models/sms.model';

export const smsApi = new SmsAPI();

/** 인증번호 발송 쿼리 훅 */
export const useSendSms = ({
  data,
  options
}: {
  data: ReqSendSms;
  options?: CommonQueryOptions<BaseApiResponse, ResultError, BaseApiResponse>;
}) => {
  const queryKeyFactory = (data: ReqSendSms) => smsKeys.SEND_SMS(data);

  const queryFn = async (data: ReqSendSms) => {
    return await smsApi.sendSms(data);
  };

  return useCommonQuery<ReqSendSms, BaseApiResponse, ResultError, BaseApiResponse>({
    data,
    options,
    queryKeyFactory,
    queryFn
  });
};

/** 인증번호 단순 검증 쿼리 훅 */
export const useVerifyCode = ({
  data,
  options
}: {
  data: ReqVerifyCode;
  options?: CommonQueryOptions<BaseApiResponse<VerifyResult>, ResultError, VerifyResult>;
}) => {
  const queryKeyFactory = (data: ReqVerifyCode) => smsKeys.VERIFY_CODE(data);

  const queryFn = async (data: ReqVerifyCode) => {
    return await smsApi.verifyCode(data);
  };

  return useCommonQuery<ReqVerifyCode, BaseApiResponse<VerifyResult>, ResultError, VerifyResult>({
    data,
    options: {
      ...options,
      select: (data: BaseApiResponse<VerifyResult>) => data.resultObject
    },
    queryKeyFactory,
    queryFn
  });
};

/** 임시 비밀번호 생성 및 발송 쿼리 훅 */
export const useSendTempPwd = ({
  data,
  options
}: {
  data: ReqTempPassword;
  options?: CommonQueryOptions<BaseApiResponse, ResultError, BaseApiResponse>;
}) => {
  const queryKeyFactory = (data: ReqTempPassword) => smsKeys.SEND_TEMP_PWD(data);

  const queryFn = async (data: ReqTempPassword) => {
    return await smsApi.sendTempPwd(data);
  };

  return useCommonQuery<ReqTempPassword, BaseApiResponse, ResultError, BaseApiResponse>({
    data,
    options,
    queryKeyFactory,
    queryFn
  });
};

/** 회원 가입 또는 모바일+국가 변경을 위한 인증코드 발송 쿼리 훅 */
export const useSendSmsForChangeNationMobile = ({
  data,
  options
}: {
  data: ReqChangeNationMobile;
  options?: CommonQueryOptions<BaseApiResponse, ResultError, BaseApiResponse>;
}) => {
  const queryKeyFactory = (data: ReqChangeNationMobile) =>
    smsKeys.SEND_SMS_FOR_CHANGE_NATION_MOBILE(data);

  const queryFn = async (data: ReqChangeNationMobile) => {
    return smsApi.sendSmsForChangeNationMobile(data);
  };

  return useCommonQuery<ReqChangeNationMobile, BaseApiResponse, ResultError, BaseApiResponse>({
    data,
    options,
    queryKeyFactory,
    queryFn
  });
};
